/**
 * Pure helpers for building the runtime "current focus" context snapshot.
 * Host-agnostic (no Office.js) so they can be unit-tested and shared by every
 * app's `<host>-context.ts` reader.
 */

/**
 * Cap `text` to at most `maxChars`, appending a truncation marker when cut so
 * the model knows the snapshot is partial. Keeps context entries lightweight
 * (they are injected into the system prompt on every turn).
 */
export function capText(text: string, maxChars: number): string {
  if (text.length <= maxChars) return text;
  const marker = `\n…[truncated ${text.length - maxChars} more chars]`;
  // If the budget can't even fit the marker, hard-slice — never exceed maxChars.
  if (marker.length >= maxChars) return text.slice(0, maxChars);
  return text.slice(0, maxChars - marker.length) + marker;
}
